module.exports = __webpack_public_path__ + "img/shoot_00012.2bf863d3.png";